import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { ReactNode } from "react";
import "./App.css";
import Home from "./Home";
import Footer from "./Footer";
import About from "./About";
import FAQ from "./FAQ";
import Contact from "./Contact";
import FinancialReview from "./Products/FinancialReview";
import Pension from "./Products/Pension";
import LifeProtection from "./Products/LifeProtection";
import Investments from "./Products/Investments";
import NavigationBar from "./NavigationBar";
import NotFoundPage from "./NotFoundPage";
import Tools from "./Tools";
import Thankyou from "./Thankyou";
import Chatbot from "./Chatbot";
import "./App.css";
import ContentHub from "./ContentHub";
import BlogDetail from "./ContentHub/BlogDetail";
interface TrailingSlashRedirectProps {
  children: ReactNode;
}

const TrailingSlashRedirect = ({ children }: TrailingSlashRedirectProps) => {
  const location = useLocation();

  if (!location.pathname.endsWith("/") && location.pathname !== "/") {
    return <Navigate to={`${location.pathname}/`} replace />;
  }

  return <>{children}</>;
};

const Layout = () => {
  const validRoutes = [
    "/",
    "/services/financial-review/",
    "/services/pension/",
    "/services/life-protection/",
    "/services/investments/",
    "/about/",
    "/faq/",
    "/contact/",
    "/resources/risk-profiler/",
    "/resources/content-hub/",
    "/thank-you/",
  ];

  const location = useLocation();
  const isValidRoute = validRoutes.includes(location.pathname) ||
  location.pathname.startsWith("/resources/content-hub/");

  return (
    <div className="App">
      {isValidRoute && (<NavigationBar /> )}
      <main>
      <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                <Footer />
              </>
            }
          />
          <Route
            path="/services/financial-review/"
            element={
              <>
                <FinancialReview />
                <Footer />
              </>
            }
          />
          <Route
            path="/services/pension/"
            element={
              <>
                <Pension />
                <Footer />
              </>
            }
          />
          <Route
            path="/services/life-protection/"
            element={
              <>
                <LifeProtection />
                <Footer />
              </>
            }
          />
          <Route
            path="/services/investments/"
            element={
              <>
                <Investments />
                <Footer />
              </>
            }
          />
          <Route
            path="/about/"
            element={
              <>
                <About />
                <Footer />
              </>
            }
          />
          <Route
            path="/faq/"
            element={
              <>
                <FAQ />
                <Footer />
              </>
            }
          />
          <Route
            path="/contact/"
            element={
              <>
                <Contact />
                <Footer />
              </>
            }
          />
          <Route
            path="/resources/risk-profiler/"
            element={
              <>
                <Tools />
                <Footer />
              </>
            }
          />
          <Route
            path="/resources/content-hub/"
            element={
              <>
                <ContentHub />
                <Footer />
              </>
            }
          />
          <Route
            path="/resources/content-hub/:slug/"
            element={
              <>
                <BlogDetail />
                <Footer />
              </>
            }
          />
          <Route
            path="/thank-you/"
            element={
              <>
                <Thankyou />
                <Footer />
              </>
            }
          />
          <Route path="/404/" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404/" replace />} />
        </Routes>
      </main>
      <Chatbot />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="*"
          element={
            <TrailingSlashRedirect>
              <Layout />
            </TrailingSlashRedirect>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
